<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="ac-header">
        Promo Wizard Help
      </div>
      <div class="ac-info-container">
        <div class="ac-info-header">
          Offer Summary
        </div>
        <div class="ac-info-body">
          <b>Name:</b> Choose a short name for the promotion that highlights its primary benefit.
        </div>
        <div class="ac-info-body">
          <b>Offer Description:</b> Use this section as a subtitle for the
          offer's name, giving a short description of what the pp is.
        </div>
      </div>
      <div class="ac-button-container">
        <button
          type="button"
          class="ac-button"
          @click="close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferSummary',
  props: {
    close: Function,
  },
};
</script>
